<template>
  <page-article>
    <div class="col-12 page_content_area">
      <div class="container">
        <div class="page_article_block col-12">
          <div class="col-12">
            <div class="page_title">
              博覽會攤位配置圖
            </div>
          </div>
          <div class="row">
            <div class="col-2 article_info_item">
              <tag
                fill
                style="basic"
              >
                詳細內容
              </tag>
            </div>
          </div>
          <div class="col-12 article_content">
            <div
              v-if="currentExpoDetailsGetter.expo_content"
              v-html="currentExpoDetailsGetter.expo_content"
            />
            <p v-else>
              尚未上傳圖片
            </p>
          </div>
          <div class="row mb-5">
            <div class="col-12">
              <h3 class="page_sub_title">
                成功選擇攤位  {{ yourEnterprisesBookedBooths.length }}/{{ yourEnterpriseCanBookBoothNumber }}
              </h3>
            </div>
            <div class="col-12 mb-3">
              <font-awesome-icon icon="exclamation-circle" />
              <span>若要刪除已成功選擇攤位號碼，請點選該號碼右邊的「Ｘ」</span>
            </div>
            <div class="col-12">
              <div class="input_wrapper d-flex">
                <tag
                  v-for="(boothNumber, index) in yourEnterprisesBookedBooths"
                  :key="`booth-chosen-${boothNumber}`"
                  :index="index"
                  :is-pill="false"
                  class="m-2"
                  color="green"
                  with-close-button
                  @remove:tag="confirmBeforeDelete(boothNumber)"
                >
                  {{ boothNumber }}
                </tag>
              </div>
            </div>
          </div>

          <div class="col-12 pl-0 d-flex">
            <h3 class="page_sub_title mb-4 mr-4">
              攤位列表
            </h3>
            <button-wrapper
              color="darken_blue"
              @click="updateBoothList(currentPage)"
            >
              刷新列表
              <font-awesome-icon icon="sync-alt" />
            </button-wrapper>
          </div>
          <div class="article_content">
            <booth-list-table
              :booked-booths="yourEnterprisesBookedBooths"
              show-booked
              @update:page="updateBoothList"
              @add:booth="submitBoothNumber"
            />
          </div>
        </div>
      </div>
    </div>
    <confirmation-modal
      :is-modal-open="openConfirmationModal"
      size="md"
      title="要刪除攤位嗎？"
      @modal:close="openConfirmationModal = false"
      @modal:okay="removeBooth"
    >
      <div class="col text-center">
        <h3>
          確認是否刪除選取號碼 <div class="badge badge-success text-wrap">
            {{ willDeleteBoothNumber }}
          </div>
        </h3>
        <p class="text-center text-danger">
          刪除後，在選位期間可能會有其他廠商選擇
        </p>
      </div>
    </confirmation-modal>
  </page-article>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import MultiSelect from 'vue-multiselect'
// import { toN } from '~utils/filters'
import pageArticle from '~components/pages/Article'
import Tag from '~components/common/Tag'
import ButtonWrapper from '~components/common/buttons'
import ConfirmationModal from '~components/common/modal/Confirmation'

import BoothListTable from '../common/BoothListTable'

export default {
  name: 'EnterpriseChooseYourBooths',
  components: {
    pageArticle,
    BoothListTable,
    // MultiSelect,
    Tag,
    ButtonWrapper,
    ConfirmationModal
  },
  data () {
    return {
      selectedBooth: '',
      selectedCount: 0,
      selectLimit: 0,
      boothOptions: [{
        number: 1
      }, {
        number: 2
      }, {
        number: 3
      }],
      currentPage: 1,
      willDeleteBoothNumber: 0,
      openConfirmationModal: false
    }
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentEnterpriseGetter',
      'currentEnterpriseCheckoutGetter'
      // 'currentExpoGetter'
    ]),
    ...mapGetters('pages/campus-recruiting', [
      'currentExpoDetailsGetter'
    ]),
    yourEnterprisesBookedBooths () {
      if (Object.keys(this.currentEnterpriseCheckoutGetter).includes('careerExpo')) {
        return this.currentEnterpriseCheckoutGetter.careerExpo.expo_booth_numbers
      }
      return []
    },
    yourEnterpriseCanBookBoothNumber () {
      if (Object.keys(this.currentEnterpriseCheckoutGetter).includes('careerExpo')) {
        return this.currentEnterpriseCheckoutGetter.careerExpo.expo_booth_quantity
      }
      return 0
    }
  },
  async created () {
    this.togglePageLoader(true)
    await this.getEnterpriseByToken()
	try {
		await this.getExpoDetailsById({ id: this.$route.params.id });
		await this.getEnrolledCampusRecruitmentById(this.$route.params.id);
	} catch (err) {
		this.$router.push('/campus-recruiting');
	}
    this.togglePageLoader(false)
    // this.updateOptions()
    // this.selectLimit = this.currentExpoGetter.expo_booth_quantity
    // this.selectedBooth = this.currentExpoGetter.expo_booth_numbers.map(number => {
    //   return {
    //     number
    //   }
    // })
  },
  methods: {
    ...mapActions('pages/campus-recruiting', [
      'getExpoDetailsById'
    ]),
    ...mapActions('pages/enterprises', [
      'getEnterpriseByToken',
      'getEnrolledCampusRecruitmentById',
      'updateExpoBooths',
      'bookingACareerExpoBooth',
      'deletingTheBookedExpoBooth'
    ]),
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    limitText (count) {
      this.selectedCount = count
      return `請刪除其中 ${count} 個選項`
    },
    async updateBoothList (page) {
      this.togglePageLoader(true)
      this.currentPage = page
      await this.getExpoDetailsById({
        id: this.$route.params.id,
        page: page || 1
      })
      await this.getEnrolledCampusRecruitmentById(this.$route.params.id)
      this.togglePageLoader(false)
    },
    async submitBoothNumber (n) {
      this.togglePageLoader(true)
      await this.bookingACareerExpoBooth({
        id: this.$route.params.id,
        boothNumber: n
      })
      await this.updateBoothList(this.currentPage)
      this.togglePageLoader(false)
    },
    async removeBooth () {
      this.openConfirmationModal = false
      this.togglePageLoader(true)
      await this.deletingTheBookedExpoBooth({
        id: this.$route.params.id,
        boothNumber: this.willDeleteBoothNumber
      })
      this.willDeleteBoothNumber = 0
      await this.updateBoothList(this.currentPage)
      this.togglePageLoader(false)
    },
    confirmBeforeDelete (boothNumber) {
      this.willDeleteBoothNumber = boothNumber
      this.openConfirmationModal = true
    }
    // async submitBoothsNumbers () {
    //   const boothNumbers = this.selectedBooth.map(booth => booth.number)
    //   await this.updateExpoBooths({
    //     id: this.$route.params.id,
    //     boothNumbers
    //   })
    //   await this.getExpoDetailsById({ id: this.$route.params.id })
    //   this.$router.push({
    //     path: `/campus-recruiting/${this.$route.params.id}/enterprise`,
    //     query: {
    //       tab: '報名紀錄'
    //     }
    //   })
    // },
    // updateOptions () {
    //   const oneToN = toN(this.currentExpoDetailsGetter.expo_total_booth_number)
    //   const options = oneToN.map(booth => {
    //     if (
    //       Object.keys(this.currentExpoDetailsGetter.expo_booths).includes(`${booth}`) &&
    //       this.currentExpoDetailsGetter.expo_booths[`${booth}`].booth_enterprise_id !== this.currentEnterpriseGetter.enterprise_id
    //     ) {
    //       // do nothing
    //     } else {
    //       return {
    //         number: booth.value
    //       }
    //     }
    //   })

    //   this.boothOptions = options
    // },

  }
}
</script>
<style>
.input_wrapper {
  height: 50px;
  border-radius: 4px;
  border: solid 1px #e6e6e6;
  background-color: white;
  padding: 0 5px;
}
</style>
